import type { ReactNode } from 'react';
import YourDataWho from './YourDataWho';
import YourDataProduct from './YourDataProduct';
import YourDataInfo3 from './YourDataInfo3';
import YourDataDeliveryDate from './YourDataDeliveryDate';
import YourDataDeliveryAddress from './YourDataDeliveryAddress';
import YourDataNotes from './YourDataNotes';
import type { WizardFormValues } from '../../../domain/customerInquiry';
import s from './YourData.module.scss';

interface YourDataProps {
  values: WizardFormValues;
}

function YourData({ values }: YourDataProps) {
  const { product, category, information, windFacilityFile } = values;
  const { end, start, notes, file } = information;

  let filenames: string[] | null = null;
  if (file || windFacilityFile) {
    filenames = [];
    if (windFacilityFile) {
      filenames.push(windFacilityFile.name);
    }
    if (file) {
      filenames.push(file.name);
    }
  }

  const data: { key: string; element: ReactNode }[] = [
    { key: 'who', element: <YourDataWho category={category} /> },
    { key: 'product', element: <YourDataProduct product={product} /> },
    { key: 'infoStep3', element: <YourDataInfo3 values={values} /> },
  ];

  if (product !== 'pvGrossanlage' && (start || end)) {
    data.push({
      key: 'dates',
      element: (
        <YourDataDeliveryDate start={start!} end={end} product={product} />
      ),
    });
  }

  data.push({
    key: 'address',
    element: <YourDataDeliveryAddress information={information} />,
  });
  data.push({
    key: 'notes',
    element: <YourDataNotes notes={notes} filenames={filenames} />,
  });

  return (
    <ol className={s.summaryGrid}>
      {data.map(({ key, element }) => (
        <li key={key} className={s.summaryElement}>
          {element}
        </li>
      ))}
    </ol>
  );
}

export default YourData;
